export const TemplateTypes = {
    UploadMetadata: "uploadmetadata",
    DocumentInfo: "documentinfo",
    DocumentListing_Table: 'documentlisting_table',
    alldocumentlisting_table : "alldocumentlisting_table",
    roleslisting_table : 'roleslisting_table',
    userslisting_table: 'userslisting_table'
}

export const DataTypes = {
    Documents: { name: 'Documents', id: 'Documents' },
    Users: { name: 'Users', id: 'Users' },
    Roles: {name: 'Roles', id: 'Roles'},
    Network: {name: 'Network', id: 'FeatureConfiguration'}
}

export const DataListTemplates = {
    versionList: 'versionList',
    myDocuments: 'myDocuments',
    allDocuments: 'allDocuments',
    news:'news'
}

export const FileAccessibilityMapping = {
    private : '1',
    public : '2',
    group : '3'
}